/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_451582f8"]'><cube-button active>激活态</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_451582f8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_451582f8"}
  /** script content **/
  require("./btn-secondary-active.mpx.js?isComponent&outputPath=components%2Fbtn-secondary-active451582f8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-secondary-active.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-secondary-active451582f8%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_451582f8"],
    ctorType: "component",
    outputPath: "components/btn-secondary-active451582f8/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>